import EbzButton from './EbzButton';

export default EbzButton;
